/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  const cartQuickViewLinks = document.querySelectorAll('.vd-link');
  if (cartQuickViewLinks.length) {
    cartQuickViewLinks.forEach((link) => {
      const handleEvent = (e) => {
        e.preventDefault(); // Prevent default action (e.g., following a link)
        let productId = link.dataset.productId;
        let quickViewEl = document.querySelector(`.cart-item-popup-indv-${productId}`);
        if (quickViewEl) {
          quickViewEl.classList.add('active');
        }
      };
  
      link.addEventListener('click', handleEvent);
      link.addEventListener('touchstart', handleEvent); // Handle touch events for better iOS support
    });
  }
	



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
